/**
 * Turns a print request into a workspace tab.
 *
 * Renders nothing: it subscribes to the print bus and navigates to the tab path
 * of the session. Lives in the app layer because it needs the router — the bus
 * itself must stay router-free (see `runtime/print/printWindowBus`).
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { subscribeOpenPrintWindow } from '@/runtime/print/printWindowBus'
import { openPrintSession } from '@/runtime/print/printSessions'

export function PrintTabOpener() {
  const navigate = useNavigate()

  useEffect(
    () =>
      subscribeOpenPrintWindow((descriptor) => {
        // Re-printing the same form reuses its session, so the existing tab is
        // activated rather than duplicated.
        const { path } = openPrintSession(descriptor)
        navigate(path)
      }),
    [navigate],
  )

  return null
}
